interface ConfigProps {
  [key: string]: {
    color: string
    bgColor: string
    bgImage?: string
    highRisk?: boolean
  }
}

const networks: ConfigProps = {
  'facebook-high-risk': {
    color: '#fff',
    bgColor: '#181A1F',
    bgImage: '/images/networks/bg/high-risk.svg',
    highRisk: true
  },
  'google-high-risk': {
    color: '#fff',
    bgColor: '#181A1F',
    bgImage: '/images/networks/bg/high-risk.svg',
    highRisk: true
  }
}
export default networks
